var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "11px",
    viewBox: "0 0 15 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-/-Fan-user",
    transform: "translate(-88.000000, -922.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "earn-more",
    transform: "translate(0.000000, 788.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,109.30198 C102.448281,109.522784 101.854844,109.672102 101.232344,109.739358 C101.867969,109.395462 102.355938,108.85149 102.585625,108.203038 C101.99125,108.521131 101.332188,108.752086 100.631406,108.87687 C100.069844,108.337127 99.2701562,108 98.3851562,108 C96.6854687,108 95.3078125,109.243184 95.3078125,110.776966 C95.3078125,110.994386 95.335,111.206306 95.3875,111.409767 C92.8295313,111.293867 90.5621875,110.188156 89.044375,108.508018 C88.7795313,108.918323 88.6276563,109.395462 88.6276563,109.904326 C88.6276563,110.867487 89.1709375,111.717708 89.9964063,112.215574 C89.4920312,112.201192 89.0176563,112.076408 88.6028125,111.868295 C88.6023438,111.880138 88.6023438,111.891559 88.6023438,111.903403 C88.6023438,113.248952 89.663125,114.371159 91.07125,114.626226 C90.8129687,114.689675 90.5410938,114.723515 90.2603125,114.723515 C90.0620313,114.723515 89.869375,114.706172 89.6814062,114.674024 C90.0728125,115.777197 91.2095312,116.580042 92.55625,116.602461 C91.5029687,117.347356 90.1759375,117.791079 88.7340625,117.791079 C88.485625,117.791079 88.2409375,117.777966 88,117.752586 C89.3617187,118.540204 90.979375,119 92.7175,119 C98.378125,119 101.473281,114.768352 101.473281,111.098866 C101.473281,110.978312 101.470469,110.858604 101.464375,110.739319 C102.065781,110.348048 102.5875,109.859066 103,109.30198",
    fill: "#ffffff",
    fillRule: "nonzero",
    id: "icon-twitter"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.9ad11575d1e82f93dff3672a4032eb81.svg";
export { ForwardRef as ReactComponent };